module.exports = __webpack_public_path__ + "static/media/typescript.4389f583.svg";